import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { DocumentiSearchPosizioneRowCircles } from 'src/app/shared/models/documento-search.model';

@Component({
  selector: 'app-documenti-list-circle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <div [ngClass]="{ circle:true, disabled:!isEnabled(), selected:isSelected() }" [style.background-color]="color()"
    [pTooltip]="tooltip()" tooltipPosition="top" [showDelay]="200" (click)="clicked()">
  </div>
  `,
  styles: [`
    .circle {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-left: 10px;
      border-radius: 100%;
      cursor: pointer;

      &.disabled {
        background-color: #b0bec5 !important;
        cursor: context-menu;
      }

      &.selected {
        border: black solid 2px;
      }
    }
  `]
})
export class DocumentiListCircleComponent {
  public color = input.required<string>();
  public filter = input.required<string>();
  public data = input<DocumentiSearchPosizioneRowCircles>();
  public changed = output<{ filter: string, value: boolean }>();

  public isEnabled = computed(() => this.currentValue().count > 0);
  public isSelected = computed(() => this.currentValue().selected);
  public tooltip = computed(() => `${this.currentValue().count} in ${this.filter()}`);

  private currentValue = computed(() => {
    const data = this.data();
    return (data?.[this.filter()]) ?? { count: 0, selected: false };
  });

  clicked(): void {
    if (this.isEnabled()) {
      this.changed.emit({ filter: this.filter(), value: !this.isSelected() });
    }
  }
}
